import { createStyles } from 'game/lib/createStyles';
import { colors, fontWeight, fonts } from 'game/styles/theme';
import { PropsWithChildren } from 'react';

interface TooltipProps {
  heading: React.ReactNode,
}

const classes = createStyles({
  tooltip: {
    border: `2px solid ${colors.black}`,
    borderRadius: 8,
    background: colors.white,
    boxShadow: `5px 5px 0 ${colors.black}`,
    fontFamily: fonts.nunito,
    padding: 10,
  },
  heading: {
    fontSize: 18,
    fontWeight: fontWeight.extraBold,
  },
  body: {
  },
});

export const Tooltip: React.FC<PropsWithChildren<TooltipProps>> = ({ heading, children }) => {
  return (
    <div className={classes.tooltip}>
      <div className={classes.heading}>
        {heading}
      </div>
      <div className={classes.body}>
        {children}
      </div>
    </div>
  );
};
